export default "__VITE_ASSET__DpJlSuv4__"